import { render, staticRenderFns } from "./EditAccessManage.vue?vue&type=template&id=c933f646&"
import script from "./EditAccessManage.vue?vue&type=script&lang=js&"
export * from "./EditAccessManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports